import _extends from "@babel/runtime/helpers/extends";
import { CloseIcon } from "@smartsheet/lodestar-icons";
import React, { forwardRef } from "react";
import { ToastAction } from "./ToastAction";
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
export var ToastDismissButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ToastAction, _extends({
    tabIndex: 0,
    ref: ref
  }, props), /*#__PURE__*/React.createElement(CloseIcon, {
    size: "small"
  }));
});
ToastDismissButton.displayName = "ToastDismissButton";
//# sourceMappingURL=ToastDismissButton.js.map